import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Button } from "react-bootstrap";
import "./style.css";

const { SearchBar, ClearSearchButton } = Search;

const customTotal = (from, to, size) => (
  <span className="ml-2 react-bootstrap-table-pagination-total">
    Showing {from} to {to} of {size} Results
  </span>
);

const options = {
  paginationSize: 4,
  pageStartIndex: 1,
  firstPageText: "First",
  prePageText: "Back",
  nextPageText: "Next",
  lastPageText: "Last",
  nextPageTitle: "First page",
  prePageTitle: "Pre page",
  firstPageTitle: "Next page",
  lastPageTitle: "Last page",
  showTotal: true,
  paginationTotalRenderer: customTotal,
  disablePageTitle: true,
};

export const RestlessTable = ({
  data,
  columns,
  withPagination = false,
  noSearchBar = false,
  withNewButton = false,
  newButton
}) => {
  return (
    <ToolkitProvider keyField="id" data={data} columns={columns} search>
      {(props) => {
        return (
          <div>
            <div className="row justify-content-end scrollTable">
              {withNewButton && (
                <div className=" justify-content-end mb-2 mr-2">
                  <Button onClick={newButton.onClick}>
                    {newButton.text}
                  </Button>
                </div>
              )}
              {!noSearchBar && (
                <>
                  <div className="d-flex align-items-center">
                    <SearchBar {...props.searchProps} />
                  </div>
                  <div>
                    <ClearSearchButton
                      className="ml-2 btn-primary"
                      {...props.searchProps}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="h-100 scrollTable">
              <BootstrapTable
                {...props.baseProps} //keyfield, data & columns from toolkitProvider
                wrapperClasses="table-responsive"
                bordered
                striped
                classes="table table-head-custom table-vertical-center scrollTable"
                bootstrap4
                pagination={withPagination && paginationFactory(options)}
              />
            </div>
          </div>
        );
      }}
    </ToolkitProvider>
  );
};

RestlessTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  withPagination: PropTypes.bool,
};
